module.exports = __webpack_public_path__ + "img/savings-providers.a5079e2.webp";